import { render, staticRenderFns } from "./NewsPage.vue?vue&type=template&id=3ad32bc5&scoped=true&"
import script from "./NewsPage.vue?vue&type=script&lang=js&"
export * from "./NewsPage.vue?vue&type=script&lang=js&"
import style0 from "./NewsPage.vue?vue&type=style&index=0&id=3ad32bc5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad32bc5",
  null
  
)

export default component.exports